import { GzLabelSwitchWebComponent } from './component/GzLabelSwitchWebComponent';

export { GzLabelSwitchWebComponent };
